<script setup lang="ts">
import Loginadminheader from '~/components/layout/admin/loginadminheader.vue';
</script>

<template>
  <div class="admin-wrap">
    <Loginadminheader />
    <div class="login-content">
      <NuxtPage />
    </div>
  </div>
</template>

<style scoped lang="scss">

</style>